/*
 * @Author: zxf
 * @Date: 2021-10-18 09:42:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-27 16:45:14
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\register\SceneRegister.js
 */
import Singleton from './../clazz/Singleton';
import { ScenePack } from "./ScenePack.js";
import { Tiles } from './../utils/Tiles.js';
import { RenderController } from "../render/RenderController.js";


export class SceneRegister extends Singleton{
	constructor(options) {
		super(options);
		this.options = options;
		this.scenes = {};
		this.tempScenes = {};
		this.maxTilesNumber = 20;

	}
  clearSceneCache (refresh, needUpdateTypes) {
    const { maxTilesNumber, scenes } = this;
    const sourceController = RenderController.getInstance().sourceController;
    const { tiles } = Tiles.getInstance().getTilesByScreenBox();
    let count = 0;

    if (needUpdateTypes) {
      needUpdateTypes.forEach(type => {
        if (scenes[type].relationFeatures) {
          const relationFeatures = scenes[type].relationFeatures;
          needUpdateTypes.push(...relationFeatures);
        }
      });
    }
    const featureConfig = RenderController.getInstance().featureConfig;

    needUpdateTypes = needUpdateTypes || Object.keys(scenes);
    for (let type in scenes) {
      if (['temporaryFeedback', 'qualityPoint', 'drivingGeofence'].includes(type)) {
        continue
      }
      count = Math.max(Object.keys(scenes[type].tiles).length, count);
    }
    if (count < maxTilesNumber && !refresh) {
      return
    }
    for (let type of needUpdateTypes) {
      const sceneTiles = scenes[type].tiles;
      const source = sourceController.getSource(type);
      const keys = Object.keys(sceneTiles);
      if (!keys.length && (featureConfig[type] && !featureConfig[type].isChild) && !['temporaryFeedback', 'qualityPoint', 'drivingGeofence'].includes(type)) {
        // scenes[type].clear();
        continue
      }
      for (let tilePixel in sceneTiles) {
        const [x, y] = tilePixel.split('_');
        const index = tiles.findIndex((i => {
          return i.x == x && i.y == y
        }));

        if (!~index || refresh) {
          scenes[type].custom_removeAndDispose(sceneTiles[tilePixel]);
          delete sceneTiles[tilePixel];
          source && source.delByTile(tilePixel);
        }
      }
    }
  }



	addScene(name, search=true) {
		const scene = new ScenePack();
        scene.name = name;
        scene.visible = true;
		scene.search = search;
		this.scenes[name] = scene;
	}

	hasScene(name) {
		return this.scenes.hasOwnProperty(name);
	}

	deleteScene(name) {
	}

	deleteAllScene(name) {
		
	}

	/**
	 * @Author: zxf
	 * @description: 清除要素
	 * @param {*} type
	 * @return {*}
	 */	
	clearFeature(type) {
        this.scenes[type].clear();
    }
	/**
	 * @Author: zxf
	 * @description: 隐藏要素
	 * @param {*} type
	 * @return {*}
	 */
    hideFeature(type) {
        this.scenes[type].visible = false;
    }
	/**
	 * @Author: zxf
	 * @description: 显示要素
	 * @param {*} type
	 * @return {*}
	 */
	showFeature(type) {
		this.scenes[type].visible = true;
	}
	/**
	 * @Author: wxs
	 * @description: 展示临时图层temp的要素
	 * @param {*} type
	 * @return {*}
	 */
	showTempFeature(type) {
		if(!this.tempScenes[type]) return
		this.tempScenes[type].children.forEach(item=>{
			item.visible = true;
		})
	}
	/**
	 * @Author: wxs
	 * @description: 隐藏临时图层temp的要素
	 * @param {*} type
	 * @return {*}
	 */
	hideTempFeature(type) {
		if(!this.tempScenes[type]) return
		this.tempScenes[type].children.forEach(item=>{
			item.visible = false;
		})
	}
	
	destroy() {
		this.tempScenes = {};
	}

	clearAll(options = []) {
		Object.keys(this.scenes).forEach(element => {
			if(!options.includes(element)) {
				this.scenes[element].clear();
			}
		});
		
	}
}